import { NgModule } from "@angular/core";
import { HeaderComponent } from "../header/header.component";
import { DefaultHeaderComponent } from "../header/default-header/default-header.component";
import { VmanicodeHeaderComponent } from "../header/vmanicode-header/vmanicode-header.component";
import { VmanicoriHeaderComponent } from "../header/vmanicori-header/vmanicori-header.component";
import { ItcHeaderComponent } from "../header/itc-header/itc-header.component";
import { FooterComponent } from "../footer/footer.component";
import { MenuComponent } from "../menu/menu.component";
import { CookieService } from "ngx-cookie-service";
import { MaterialDesignModule } from "../material-design/material-design.module";
import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { FlexLayoutModule } from "@angular/flex-layout";
import { RouterModule } from "@angular/router";
import { NgxSpinnerModule } from "ngx-spinner";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { StarRatingComponent } from "../star-rating/star-rating.component";
import { TermsAndConditionsStepperComponent } from "../terms-and-conditions-stepper/terms-and-conditions-stepper.component";
import { PdfViewerModule } from "ng2-pdf-viewer";
import { RedirectToLoginComponent } from "../components/redirect-to-login/redirect-to-login.component";
import { ReadBlogComponent } from "../read-blog/read-blog.component";
import { HighlightPipe } from "../services/hightlight.pipe";
import { MarkdownModule } from "ngx-markdown";
import { LazyLoadImageDirective } from "./lazy-load-image.directive";
import { ContactUsFormComponent } from "../components/contact-us-form/contact-us-form.component";
import { SubscribeNewsletterComponent } from "../components/subscribe-newsletter/subscribe-newsletter.component";
import { DownloadBrochureComponent } from "../download-brochure/download-brochure.component";
import { ReplaceVmanicoPipe } from "../services/replace-vmanico.pipe";
import { MatSidenavModule } from '@angular/material/sidenav';
import { VmanicosiHeaderComponent } from "../header/vmanicosi-header/vmanicosi-header.component";
import { CookieConsentComponent } from "../cookie-consent/cookie-consent.component";
import { CookieSettingsComponent } from "../cookie-settings/cookie-settings.component";


@NgModule({
    declarations: [
        HighlightPipe,
        ReplaceVmanicoPipe,
        HeaderComponent,
        FooterComponent,
        MenuComponent,
        CookieConsentComponent,
        CookieSettingsComponent,
        StarRatingComponent,
        RedirectToLoginComponent,
        TermsAndConditionsStepperComponent,
        ReadBlogComponent,
        ContactUsFormComponent,
        SubscribeNewsletterComponent,
        LazyLoadImageDirective,
        DownloadBrochureComponent,
        DefaultHeaderComponent,
        VmanicodeHeaderComponent,
        VmanicoriHeaderComponent,
        VmanicosiHeaderComponent,
        ItcHeaderComponent,
    ],
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        FlexLayoutModule,
        MatSidenavModule,
        NgxSpinnerModule.forRoot(),
        MaterialDesignModule,
        PdfViewerModule,
        MarkdownModule.forRoot(),
    ],
    exports: [
        HighlightPipe,
        ReplaceVmanicoPipe,
        HeaderComponent,
        FooterComponent,
        MenuComponent,
        CookieConsentComponent,
        CookieSettingsComponent,
        StarRatingComponent,
        RedirectToLoginComponent,
        TermsAndConditionsStepperComponent,
        ReadBlogComponent,
        ContactUsFormComponent,
        SubscribeNewsletterComponent,
        LazyLoadImageDirective,
        DownloadBrochureComponent,
        DefaultHeaderComponent,
        VmanicodeHeaderComponent,
        VmanicoriHeaderComponent,
        ItcHeaderComponent,
    ],
    providers: [
        CookieService,
    ]
})


export class SharedModule { }